// downloadableFrom arrives from the API as a UTC ISO string, e.g. "2026-10-16T12:00:00Z".
// Until that moment the API sends the book without its file, plus downloadableIn: the
// seconds still to go, counted on the server's clock.

const SECOND = 1000;

// Pins each scheduled book's remaining seconds to this browser's clock as opensAt, at
// the moment the list arrives. Counting down to opensAt rather than to downloadableFrom
// keeps every countdown in step with the server, even when the visitor's clock is off.
export const withOpeningTimes = (library, receivedAt = Date.now()) =>
  library.map((book) =>
    book.downloadableIn ? { ...book, opensAt: receivedAt + book.downloadableIn * SECOND } : book,
  );

// The next download opening still ahead: when it comes (opensAt), the admin-set moment
// for the label (downloadableFrom) and the books that open then. Null when nothing is
// scheduled. Later openings get their turn once this one has passed.
export const nextDownloadOpening = (library, now = Date.now()) => {
  const upcoming = library.filter((book) => book.opensAt > now);
  if (upcoming.length === 0) {
    return null;
  }

  const first = upcoming.reduce((earliest, book) =>
    book.opensAt < earliest.opensAt ? book : earliest,
  );

  return {
    opensAt: first.opensAt,
    downloadableFrom: first.downloadableFrom,
    books: upcoming.filter((book) => book.downloadableFrom === first.downloadableFrom),
  };
};

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const pad = (value) => String(value).padStart(2, '0');

// "16 October 2026 at 12:00 UTC", whatever the visitor's own timezone or locale.
export const formatDownloadOpening = (moment) => {
  const date = new Date(moment);

  return `${date.getUTCDate()} ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()} at ${pad(
    date.getUTCHours(),
  )}:${pad(date.getUTCMinutes())} UTC`;
};
